import { css } from '@/styled-system/css';

/**
 * Visually hides an element while keeping it readable by screen readers and
 * other assistive tech. Standard "sr-only" utility — preferred over
 * `display: none` or `visibility: hidden` when the content needs to remain
 * announced.
 */
export const visuallyHidden = css({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
